import api from './api';

export interface AutomationLog {
  id: number;
  recipientId: number;
  leadId: number | null;
  fromStageId: number | null;
  toStageId: number | null;
  result: string;
  source: string;
  skipDetail: string | null;
  createdAt: string;
  lead?: {
    id: number;
    name: string;
    email: string | null;
    integrationId?: number | null;
    externalCreatedAt?: string | null;
    externalDocsGenerated?: number | null;
    externalDocsUsed?: number | null;
    externalDocsLimit?: number | null;
    externalFirstDocAt?: string | null;
    externalLastActivityAt?: string | null;
    externalTriedLockedFeature?: boolean | null;
    externalTotalTokens?: number | null;
  } | null;
  fromStage?: { id: number; name: string } | null;
  toStage?: { id: number; name: string } | null;
}

export const leadAutomationService = {
  async runForCampaign(campaignId: number): Promise<{ enqueued: number }> {
    const res = await api.post(`/mail-campaigns/${campaignId}/run-automation`);
    return res.data.data;
  },
  async getLogs(
    campaignId: number,
    opts: { lifecycleStage?: string } = {}
  ): Promise<{ summary: Record<string, number>; logs: AutomationLog[] }> {
    const res = await api.get(`/mail-campaigns/${campaignId}/automation-logs`, {
      params: opts.lifecycleStage ? { lifecycleStage: opts.lifecycleStage } : undefined,
    });
    return res.data.data;
  },
};

export default leadAutomationService;
